module.exports = __webpack_public_path__ + "cc73664d6f051af3ed53df7f48359ac4.svg";